// Configuration Vuex Module
export const ConfigModule = {
  namespaced: true,

  getters: {
    getIPFSHost: (state) => "realitems-ipfs.s3.us-east-1.amazonaws.com",
  },
};
